import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  gap: 20px;
`;
export const Head = styled(Container)`
  padding: 0;
  gap: 10px;
`;

export const Title = styled(Typography.Header)`
  text-align: center;
`;

export const Message = styled(Typography.Body)`
  text-align: center;
  color: ${({ theme }) => theme.palette.primary.labels};
`;

export const Body = styled.div`
  display: grid;
  gap: 15px;
  padding: 20px 0;
  border-top: ${({ theme }) => `1px dashed ${theme.palette.primary.border}`};
  border-bottom: ${({ theme }) => `1px dashed ${theme.palette.primary.border}`};
  width: 100%;
`;

export const Row = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
`;

export const Label = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Value = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-align: right;
`;

export const Actions = styled.div`
  margin-top: 10px;
  width: 100%;
`;
